import React, { Component } from "react";
import { Grid } from "semantic-ui-react";
import Discover from "../img/studying.original.png";
import Showcase from "../img/dentist.original.png";
import Share from "../img/work.original.png";

class WhyJoinSection extends Component {
  render() {
    return (
      <Grid stackable textAlign="center" columns={3}>
        <Grid.Row>
          <Grid.Column>
            <img className="-feature-img" src={Discover} alt="Discover great dental cases of global dental experts." />
            <p className="-feature-title">Discover great dental cases of global dental experts.</p>
          </Grid.Column>
          <Grid.Column>
            <img className="-feature-img" src={Showcase} alt="Showcase your amazing dental skills." />
            <p className="-feature-title">Showcase your amazing dental skills.</p>
          </Grid.Column>
          <Grid.Column>
            <img className="-feature-img -less-the-size" src={Share} alt="Share with colleagues and friends." />
            <p className="-feature-title">Share with colleagues and friends.</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default WhyJoinSection;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/WhyJoinSection.js